import React, { forwardRef, ReactElement } from 'react';
import { Chip, ChipProps } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface Props extends ChipProps {
  label: string;
  onDelete: () => void;
  avatar?: ReactElement;
}

const FilterChip = forwardRef<any, Props>(({ avatar, label, onDelete, ...rest }, ref) => {
  return (
    <Chip
      ref={ref}
      clickable
      variant="outlined"
      label={label}
      avatar={avatar}
      deleteIcon={<CloseIcon fontSize="small" />}
      onDelete={onDelete}
      {...rest}
    />
  );
});

export default FilterChip;
